var s = {
  Career: {
    1: {
      zh: '银行/金融/证券/保险',
      ja: '銀行/金融/証券/保険',
      en: 'Annual Leave'
    },
    2: {
      zh: '房地产/建筑/房屋中介',
      ja: '不動産/建設',
      en: 'Rotate Days Off'
    },
    3: {
      zh: '计算机互联网',
      ja: 'IT',
      en: 'Personal Leave'
    },
    4: {
      zh: '教育/研究',
      ja: '教育/研究',
      en: 'Personal Leave'
    },
    5: {
      zh: '制造/物流',
      ja: '製造/物流',
      en: 'Personal Leave'
    },
    6: {
      zh: '服务业',
      ja: 'サービス',
      en: 'Personal Leave'
    },
    7: {
      zh: '医疗/健康',
      ja: '医療/健康',
      en: 'Personal Leave'
    },
    8: {
      zh: '零售业',
      ja: '小売/販売',
      en: 'Personal Leave'
    },
    9: {
      zh: '非盈利机构',
      ja: '非営利',
      en: 'Personal Leave'
    },
    10: {
      zh: '政府',
      ja: '政府',
      en: 'Personal Leave'
    },
    11: {
      zh: '电商',
      ja: 'ネット通販',
      en: 'Personal Leave'
    },
    12: {
      zh: '其他',
      ja: 'その他',
      en: 'Personal Leave'
    }
  },
  FlowType: {
    1: {
      zh: '年假',
      ja: '有休',
      en: 'Annual Leave'
    },
    2: {
      zh: '换休',
      ja: '振替',
      en: 'Rotate Days Off'
    },
    3: {
      zh: '事假',
      ja: '私用',
      en: 'Personal Leave'
    }
  },
  CalendarType: {
    1: {
      zh: '周六',
      ja: '土曜日',
      en: 'Saturday'
    },
    2: {
      zh: '周日',
      ja: '日曜日',
      en: 'Sunday'
    },
    3: {
      zh: '事假',
      ja: '休み',
      en: 'Day Off'
    },
    4: {
      zh: '活动',
      ja: 'イベント',
      en: 'Event'
    },
    5: {
      zh: '部分休息',
      ja: '一部休み',
      en: 'Templete Day Off'
    }
  },
  SubjectType: {
    1: {
      zh: '语文',
      ja: '国語',
      en: 'Language'
    },
    2: {
      zh: '数学',
      ja: '数学',
      en: 'Mathematics'
    },
    3: {
      zh: '英语',
      ja: '英語',
      en: 'English'
    }
  },
  NoteTag: {
    red: {
      zh: '红色',
      ja: '赤色',
      en: 'Red'
    },
    green: {
      zh: '绿色',
      ja: '緑色',
      en: 'Green'
    },
    blue: {
      zh: '蓝色',
      ja: '青色',
      en: 'Blue'
    },
    yellow: {
      zh: '黄色',
      ja: '黄色',
      en: 'Yellow'
    },
    gray: {
      zh: '灰色',
      ja: '灰色',
      en: 'Gray'
    }
  },
  Priority: {
    0: {
      zh: '低',
      ja: '低め',
      en: 'Low'
    },
    1: {
      zh: '通常',
      ja: '通常',
      en: 'Normal'
    },
    2: {
      zh: '高',
      ja: '高め',
      en: 'High'
    },
    8: {
      zh: '紧急',
      ja: '急いで',
      en: 'Hurried'
    },
    9: {
      zh: '马上',
      ja: '今すぐ',
      en: 'Right Now'
    }
  },
  Progress: {
    0: {
      zh: '0%',
      ja: '0%',
      en: '0%'
    },
    30: {
      zh: '30%',
      ja: '30%',
      en: '30%'
    },
    50: {
      zh: '50%',
      ja: '50%',
      en: '50%'
    },
    70: {
      zh: '70%',
      ja: '70%',
      en: '70%'
    },
    90: {
      zh: '90%',
      ja: '90%',
      en: '90%'
    },
    100: {
      zh: '100%',
      ja: '100%',
      en: '100%'
    }
  },
  BaseRole: {
    admin: {
      zh: '管理者',
      ja: '管理者',
      en: 'Administrator'
    },
    owner: {
      zh: '所有者',
      ja: '所有者',
      en: 'Owner'
    }
  },
  QuestionType: {
    1: {
      zh: '单选题',
      ja: '選択',
      en: 'Single Choice'
    },
    2: {
      zh: '多选题',
      ja: 'マルチ選択',
      en: 'Multiple Choice'
    },
    3: {
      zh: '填空题',
      ja: '空欄埋め',
      en: 'Completion'
    }
  },
  SexType: {
    1: {
      zh: '男',
      ja: '男性',
      en: 'Man'
    },
    2: {
      zh: '女',
      ja: '女性',
      en: 'Women'
    }
  },
  Marital: {
    1: {
      zh: '未婚',
      ja: '未婚',
      en: 'Unmarried'
    },
    2: {
      zh: '已婚',
      ja: '既婚',
      en: 'Married'
    },
    3: {
      zh: '离异',
      ja: '離婚',
      en: 'Divorce'
    }
  },
  Political: {
    1: {
      zh: '',
      ja: '未婚',
      en: 'Unmarried'
    },
    2: {
      zh: '已婚',
      ja: '既婚',
      en: 'Married'
    },
    3: {
      zh: '离异',
      ja: '離婚',
      en: 'Divorce'
    }
  },
  Degree: {
    1: {
      zh: '本科',
      ja: '博士',
      en: 'Doctor'
    },
    2: {
      zh: '专科',
      ja: '女性',
      en: 'Women'
    },
    3: {
      zh: '中职',
      ja: '女性',
      en: 'Women'
    }
  },
  OrgType: {
    1: {
      zh: '部门',
      ja: '部門',
      en: 'Org'
    },
    2: {
      zh: '岗位',
      ja: '職務',
      en: 'Position'
    },
    3: {
      zh: '群组',
      ja: 'グループ',
      en: 'Group'
    }
  },
  RoleType: {
    0: {
      zh: '基本权限',
      ja: '基本権限',
      en: 'Base Permission'
    },
    1: {
      zh: '职务权限',
      ja: '職務権限',
      en: 'Position Permission'
    }
  },
  TimeCycle: {
    1: {
      zh: '每日',
      ja: '毎日',
      en: 'Daily'
    },
    2: {
      zh: '每周',
      ja: '毎週',
      en: 'Weekly'
    }
  },
  OnStatus: {
    0: {
      zh: '停用',
      ja: '停止',
      en: 'Off'
    },
    1: {
      zh: '正常',
      ja: '正常',
      en: 'On'
    }
  },
  ReserveStatus: {
    0: {
      zh: '未支付',
      ja: '未支払い',
      en: 'Not Paid',
      class: "badge badge-warning"
    },
    1: {
      zh: '待确认',
      ja: '予約中',
      en: 'Not Confirmed',
      class: "badge badge-warning"
    },
    2: {
      zh: '待服务',
      ja: '確定済み',
      en: 'Confirmed',
      class: "badge badge-success"
    },
    3: {
      zh: '已完成',
      ja: '来店済',
      en: 'Finished',
      class: "badge badge-info"
    },
    4: {
      zh: '顾客取消',
      ja: '顧客取消',
      en: 'Cancelled By Customer',
      class: "badge badge-secondary"
    },
    5: {
      zh: '商家取消',
      ja: '店舗取消',
      en: 'Cancelled By Shop',
      class: "badge badge-secondary"
    }
  },
  DefStatus: {
    0: {
      zh: '未启用',
      ja: '未開始',
      en: 'not ready',
      class: 'text-info'
    },
    1: {
      zh: '进行中',
      ja: '使用中',
      en: 'in process',
      class: 'text-success'
    },
    2: {
      zh: '暂停',
      ja: '停止中',
      en: 'stopped',
      class: 'text-muted'
    },
    9: {
      zh: '已结束',
      ja: '完了',
      en: 'finished',
      class: 'text-secondary'
    }
  },
  JudgeStatus: {
    0: {
      zh: '不合格',
      ja: '不合格',
      en: 'Failed'
    },
    1: {
      zh: '合格',
      ja: '合格',
      en: 'Passed'
    }
  },
  UseStatus: {
    0: {
      zh: '进行中',
      ja: '進行中',
      en: 'in processing'
    },
    1: {
      zh: '未使用',
      ja: '未使用',
      en: 'not used'
    },
    2: {
      zh: '已过期',
      ja: '期限切れ',
      en: 'outdated'
    },
    9: {
      zh: '已使用',
      ja: '使用済',
      en: 'used'
    }
  },
  OrderStatus: {
    1: {
      zh: '已下单',
      ja: '注文済',
      en: 'Ordered'
    },
    2: {
      zh: '订单确认',
      ja: '確定済',
      en: 'Confirmed'
    },
    3: {
      zh: '待支付',
      ja: '未支払',
      en: 'Unpaid'
    },
    4: {
      zh: '已付款',
      ja: '支払済',
      en: 'Paid'
    },
    5: {
      zh: '已发货',
      ja: '発送済',
      en: 'Shipped'
    },
    6: {
      zh: '已收货',
      ja: '受取済',
      en: 'Received'
    },
    7: {
      zh: '已完成',
      ja: '取引完了',
      en: 'Completed'
    },
    8: {
      zh: '已取消',
      ja: 'キャンセル',
      en: 'Cancel'
    }
  },
  CodeType: {
    method: {
      zh: '方法',
      ja: '関数',
      en: 'Method'
    },
    for: {
      zh: 'For循环',
      ja: 'Forループ',
      en: 'For Loop'
    },
    call: {
      zh: '调用',
      ja: '呼び出し',
      en: 'Call'
    },
    if: {
      zh: 'If条件',
      ja: 'If文',
      en: 'If condition'
    },
    block: {
      zh: '代码块',
      ja: 'ブロック',
      en: 'Block'
    }
  },
  DisplayRange: {
    0: {
      zh: '显示所有',
      ja: 'すべて表示',
      en: 'Display All'
    },
    1: {
      zh: '不显示过去数据',
      ja: '過去データ表示しない',
      en: 'Do not Display Past Data'
    }
  }
};
export default s;
